import React from "react"

import { Components, Theme } from "@mui/material/styles"
import { TriangleAlert } from "lucide-react"

import { IconWrapper } from "@components/IconWrapper"

import { yellow } from "@constants/colors"

import { ThemeProps } from "./types"

export const muiAlert = ({
  darkMode,
}: ThemeProps): Components<Omit<Theme, "components">>["MuiAlert"] => {
  return {
    styleOverrides: {
      root: {
        severity: {
          warning: {
            root: {
              color: darkMode ? yellow[100] : yellow[800],
              backgroundColor: darkMode ? yellow[800] : yellow[200],
            },
          },
        },
      },
    },
    defaultProps: {
      iconMapping: {
        warning: (
          <IconWrapper
            sx={{
              fontSize: "inherit",
              color: darkMode ? yellow[100] : yellow[800],
            }}
            size={24}
          >
            <TriangleAlert />
          </IconWrapper>
        ),
      },
    },
  }
}
